import { AncillaryItemDescriptionViewModel } from "./AncillaryItemDescriptionViewModel";

export class AncillaryItemGridItem {
    constructor(
        public ItemKey: number,
        public IsSelected: boolean,
        public IsRequired: boolean,
        public IsDisabled: boolean,
        public IsGroup: boolean,
        public Cost: number,
        public Name: string,
        public Description: string,
        public Descriptions: AncillaryItemDescriptionViewModel[]) {
    }
}
